import { render } from "./TwoColumnFormLayout.vue?vue&type=template&id=39ec6a80"
import script from "./TwoColumnFormLayout.vue?vue&type=script&lang=js"
export * from "./TwoColumnFormLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__